// extracted by mini-css-extract-plugin
export default {"mainContainer":"company_detail_mainContainer__tzhAW","subContainer":"company_detail_subContainer__jkibd"};